import PageFullscreen from './components/Fullscreen';

export default PageFullscreen;


// WEBPACK FOOTER //
// ./routes/fullscreen/index.js